import z from "zod";

const utilsErrorTypeValues = [
  "EXCEEDED_MAX_RETRIES",
  "EXTERNAL_SERVICE_DISABLED_NON_REMI_EMAIL",
  "FIELD_NOT_ALLOWED_IN_FILTERS",
  "INVALID_FILTER_VALUE",
] as const;

const utilsErrorTypeSchema = z.enum(utilsErrorTypeValues);
const UtilsErrorType = utilsErrorTypeSchema.enum;
type UtilsErrorType = z.infer<typeof utilsErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type UtilsErrors =
  | {
      errorType: typeof UtilsErrorType.EXCEEDED_MAX_RETRIES;
      data: undefined;
    }
  | {
      errorType: typeof UtilsErrorType.FIELD_NOT_ALLOWED_IN_FILTERS;
      data: {
        field: string;
        allowedFields: string[];
      };
    }
  | {
      errorType: typeof UtilsErrorType.INVALID_FILTER_VALUE;
      data: {
        comparator: string;
        value: string | number | boolean | Date | string[] | null;
      };
    }
  | { errorType: typeof UtilsErrorType.EXTERNAL_SERVICE_DISABLED_NON_REMI_EMAIL; data: { email: string } };

export const utilsErrorDetails: Record<UtilsErrorType, ErrorDetails> = {
  [UtilsErrorType.EXCEEDED_MAX_RETRIES]: {
    sentryDescription: "Operation exceeded maximum retry attempts",
  },
  [UtilsErrorType.EXTERNAL_SERVICE_DISABLED_NON_REMI_EMAIL]: {
    sentryDescription: "External service is disabled in non-production environments for non remi emails",
  },
  [UtilsErrorType.FIELD_NOT_ALLOWED_IN_FILTERS]: {
    sentryDescription: "Field not allowed in filters for query compilation",
  },
  [UtilsErrorType.INVALID_FILTER_VALUE]: {
    sentryDescription: "Invalid filter value provided for query compilation",
  },
};
